import styled from '@emotion/styled';
import { useNavigate } from 'react-router-dom';
import Button from '~/components/Button';
import Gap from '~/components/Gap';
import Text from '~/components/Text';
import { ADD_ESTIMATE_ROUTE, BILLING_ROUTE } from '~/constants/routes';
import { useUserLimits } from '~/hooks/useUserLimits';
import EstimateIcon from '~/icons/EstimateIcon';
import { analytics, ANALYTICS_EVENTS } from '~/services/analyticsService';
import { useIsDesktop } from '~/hooks/useIsDesktop';

const IconWrapper = styled.div`
  min-width: 104px;
  min-height: 104px;
  max-width: 104px;
  max-height: 104px;
  border-radius: 8px;
  background-color: #f7f5ff;
`;

const EmptyEstimateList = () => {
  const navigate = useNavigate();
  const isDesktop = useIsDesktop();
  const { canCreateEstimate } = useUserLimits();

  const handleAddEstimate = () => {
    analytics.capture(ANALYTICS_EVENTS.BUTTON_CLICKED, {
      screen_name: 'Estimates',
      button_name: 'Create Estimate',
      button_id: 'create_estimate',
      section: 'Empty View',
    });

    if (canCreateEstimate) {
      navigate(ADD_ESTIMATE_ROUTE);
    } else {
      navigate(`${BILLING_ROUTE}?ref=estimates`);
    }
  };

  return (
    <div className="v-center">
      <Gap t={60} />
      <IconWrapper className="center">
        <EstimateIcon size={42} fill="var(--t-black)" />
      </IconWrapper>
      <Gap t={32} />
      <Text size={isDesktop ? 'md' : 'smd'} className="bold">
        No estimates found
      </Text>
      <Gap t={24} />
      <Text style={{ textAlign: 'center' }}>
        Create your first professional looking estimate right now.
      </Text>
      <Gap t={24} />
      <Button size="smd" onClick={handleAddEstimate}>
        Create Estimate
      </Button>
    </div>
  );
};

export default EmptyEstimateList;
